import { MobileNavigation } from "@/components/MobileNavigation";
import { DesktopNavigation } from "@/components/DesktopNavigation";
import { AnalyticsDaily } from "@/components/AnalyticsDaily";
import { AnalyticsWeekly } from "@/components/AnalyticsWeekly";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

const Analytics = () => {
  return (
    <div className="min-h-screen bg-gray-50 pb-20 md:pb-0">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-2xl font-bold text-gray-900">Analytics</h1>
          <DesktopNavigation />
        </div>

        <Tabs defaultValue="daily" className="w-full">
          <TabsList className="grid w-full grid-cols-3">
            <TabsTrigger value="daily">Daily</TabsTrigger>
            <TabsTrigger value="weekly">Weekly</TabsTrigger>
            <TabsTrigger value="monthly">Monthly</TabsTrigger>
          </TabsList>
          <TabsContent value="daily">
            <AnalyticsDaily />
          </TabsContent>
          <TabsContent value="weekly">
            <AnalyticsWeekly />
          </TabsContent>
          <TabsContent value="monthly">
            <div className="flex items-center justify-center h-40">
              <p className="text-lg text-gray-500">Coming soon</p>
            </div>
          </TabsContent>
        </Tabs>
      </div>
      <MobileNavigation />
    </div>
  );
};

export default Analytics;